var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { MasterService } from '@app/utility/master.service';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@env/environment';
var CustomerType;
(function (CustomerType) {
    CustomerType[CustomerType["Company"] = 1] = "Company";
    CustomerType[CustomerType["Person"] = 2] = "Person";
})(CustomerType || (CustomerType = {}));
;
var ProfileRegisterComponent = /** @class */ (function () {
    function ProfileRegisterComponent(Fb, Util, Api, MasterService, Router, Sanitazer) {
        this.Fb = Fb;
        this.Util = Util;
        this.Api = Api;
        this.MasterService = MasterService;
        this.Router = Router;
        this.Sanitazer = Sanitazer;
        this.DocumentList = [];
        this.FileList = [];
        this.Type = CustomerType.Company;
        this.AcceptChecked = false;
        this.isShownConsent = false;
        this.form = this.Fb.group({
            "contactid": "",
            "dpa_contacttype": "",
            "dpa_personaltypeid": "",
            "dpa_personaltypeidname": "",
            "firstname": "",
            "lastname": "",
            "dpa_idcard": "",
            "dpa_passport": "",
            "birthdate": "",
            "telephone1": "",
            "dpa_accountno": "",
            "dpa_companytypeid": "",
            "dpa_companytypeidname": "",
            "dpa_companyname": "",
            "dpa_registrationid": "",
            "dpa_authorizedperson": "",
            "dpa_authorizedperson_idcard": "",
            "dpa_authorizedperson_telephone": "",
            "emailaddress1": "",
            "dpa_contact_homeno": "",
            "dpa_contact_moo": "",
            "dpa_contact_street": "",
            "dpa_contact_subdistict": "",
            "dpa_contact_subdistictname": "",
            "dpa_contact_distict": "",
            "dpa_contact_distictname": "",
            "dpa_contact_province": "",
            "dpa_contact_provincename": "",
            "dpa_contact_postcode": "",
            "dpa_contact_postcodename": "",
            "dpa_contact_country": "",
            "dpa_contact_countryname": "",
            "dpa_allowemail": "",
            "dpa_allowsms": "",
            "dpa_approvalticketid": "",
            "dpa_name": "",
            "dpa_contactid": "",
            "dpa_submitdate": "",
            "dpa_originalsource": "2",
            "dpa_approvalstatuscode": "01",
            "dpa_approvalstatusid": "",
            "dpa_documentchecklist": "",
            "dpa_attachsizing": "0",
            "dpa_agentbankflag": true,
            "dpa_portalflag": false,
            "attachfilelist": []
        });
        this.ticket = this.Fb.group({
            "dpa_approvalticketid": "",
            "dpa_name": "",
            "dpa_contactid": "",
            "dpa_submitdate": "",
            "dpa_originalsource": "2",
            "dpa_approvalstatuscode": "01",
            "dpa_approvalstatusid": "",
            "dpa_documentchecklist": "",
            "dpa_attachsizing": "0",
            "attachfilelist": []
        });
    }
    ProfileRegisterComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            // this.Util.ShowWaiting(true);
            function match(params, data) {
                if ($.trim(params.term) === '') {
                    return data;
                }
                if (typeof data.text === 'undefined') {
                    return null;
                }
                if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) < 0)
                    return null;
                else
                    return data;
            }
            var thisTs, _a, TableDocs;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        thisTs = this;
                        $('.selectCompany').select2({
                            matcher: thisTs.MatchItem
                        });
                        $('.selectPerson').select2({
                            matcher: thisTs.MatchItem
                        });
                        $('.selectAddress').select2({
                            matcher: function (params, data) {
                                if ($.trim(params.term) === '') {
                                    return data;
                                }
                                // Do not display the item if there is no 'text' property
                                if (typeof data.text === 'undefined') {
                                    return null;
                                }
                                if (params.term.length > 1) {
                                    // `params.term` should be the term that is used for searching
                                    // `data.text` is the text that is displayed for the data object
                                    var cris = params.term.split(" ");
                                    var found = true;
                                    for (var i = 0; i < cris.length; i++) {
                                        if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
                                            found = false;
                                            return null;
                                        }
                                    }
                                    if (found) {
                                        // You can return modified objects from here
                                        // This includes matching the `children` how you want in nested data sets
                                        return data;
                                    }
                                }
                                // Return `null` if the term should not be displayed
                                return null;
                            },
                            placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
                        });
                        return [4 /*yield*/, this.InitDropdown()];
                    case 1:
                        _b.sent();
                        $('.selectAddress').on("change", function (e) {
                            thisTs.AddressChange(e.target.value);
                        });
                        $('.selectCompany').on("change", function (e) {
                            thisTs.CompanyTypeChange(e.target.value);
                            $('.docCheck').on("change", function (e) {
                                thisTs.SelectDocument(e.target);
                            });
                        });
                        $('.selectPerson').on("change", function (e) {
                            thisTs.PersonTypeChange(e.target.value);
                            $('.docCheck').on("change", function (e) {
                                thisTs.SelectDocument(e.target);
                            });
                        });
                        this.AcceptExtension = environment.AcceptUploadFileExtension;
                        _a = this;
                        return [4 /*yield*/, this.MasterService.GetMaxUploadFileSize()];
                    case 2:
                        _a.MaxTotalSizeMB = _b.sent();
                        this.CreateTableFile();
                        TableDocs = $('#TableDocs');
                        TableDocs.on('click', 'tbody tr td [role=view]', function () {
                            thisTs.ViewFile($(this).attr('url'), $(this).attr('filename'));
                        });
                        TableDocs.on('click', 'tbody tr td [role=delete]', function () {
                            thisTs.DeleteFile($(this).attr('filename'));
                        });
                        this.CompanyTypeChange($("#Type_Company").val());
                        $('.docCheck').on("change", function (e) {
                            thisTs.SelectDocument(e.target);
                        });
                        $("#dpa_idcard").on("keypress", function (e) {
                            return thisTs.NumericKey(e);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ProfileRegisterComponent.prototype.MatchItem = function (params, data) {
        if ($.trim(params.term) === '') {
            return data;
        }
        if (typeof data.text === 'undefined') {
            return null;
        }
        var found = true;
        if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) < 0)
            return null;
        else
            return data;
    };
    ProfileRegisterComponent.prototype.InitDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.Util.ShowWaiting(true);
                        this.CompanyTypeList = JSON.parse(localStorage.getItem("companyType"));
                        if (!(this.CompanyTypeList == null || this.CompanyTypeList.length == 0)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.Api.get("master", "companyType")];
                    case 1:
                        _a.CompanyTypeList = _e.sent();
                        localStorage.setItem("companyType", JSON.stringify(this.CompanyTypeList));
                        _e.label = 2;
                    case 2:
                        this.PersonTypeList = JSON.parse(localStorage.getItem("personalType"));
                        if (!(this.PersonTypeList == null || this.PersonTypeList.length == 0)) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this.Api.get("master", "personalType")];
                    case 3:
                        _b.PersonTypeList = _e.sent();
                        localStorage.setItem("personalType", JSON.stringify(this.PersonTypeList));
                        _e.label = 4;
                    case 4:
                        this.AddressList = JSON.parse(localStorage.getItem("address"));
                        if (!(this.AddressList == null || this.AddressList.length == 0)) return [3 /*break*/, 6];
                        _c = this;
                        return [4 /*yield*/, this.Api.getMasterAddress()];
                    case 5:
                        _c.AddressList = _e.sent();
                        localStorage.setItem("address", JSON.stringify(this.AddressList));
                        _e.label = 6;
                    case 6:
                        _d = this;
                        return [4 /*yield*/, this.Api.get("master", "approvalStatus")];
                    case 7:
                        _d.masterStatus = _e.sent();
                        this.Util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    ProfileRegisterComponent.prototype.CustomerTypeChange = function (target) {
        var thisTs = this;
        this.ResetForm();
        if (target.id == "Person") {
            $("#divIndividual").removeClass("hidden");
            $("#divNonIndividual").addClass("hidden");
            this.PersonTypeChange($("#Type_Person").val());
            this.Type = CustomerType.Person;
            this.form.controls["dpa_companytypeid"].setValue("");
            this.form.controls["dpa_companytypeidname"].setValue("");
        }
        else {
            $("#divIndividual").addClass("hidden");
            $("#divNonIndividual").removeClass("hidden");
            this.CompanyTypeChange($("#Type_Company").val());
            this.Type = CustomerType.Company;
            this.form.controls["dpa_personaltypeid"].setValue("");
            this.form.controls["dpa_personaltypeidname"].setValue("");
        }
        $('.docCheck').on("change", function (e) {
            thisTs.SelectDocument(e.target);
        });
    };
    ProfileRegisterComponent.prototype.AddressChange = function (value) {
        if (this.AddressList == null)
            return;
        var Rec = this.AddressList.filter(function (a) { return a.id == value; });
        if (Rec != null && Rec.length > 0) {
            var Values = Rec[0].id.split("|");
            var Text_1 = Rec[0].text.split("|");
            this.form.controls["dpa_contact_subdistict"].setValue(Values[0].trim());
            this.form.controls["dpa_contact_distict"].setValue(Values[1].trim());
            this.form.controls["dpa_contact_province"].setValue(Values[2].trim());
            this.form.controls["dpa_contact_postcode"].setValue(Values[3].trim());
            this.form.controls["dpa_contact_country"].setValue(Values[4].trim());
            this.form.controls["dpa_contact_subdistictname"].setValue(Text_1[0].trim());
            this.form.controls["dpa_contact_distictname"].setValue(Text_1[1].trim());
            this.form.controls["dpa_contact_provincename"].setValue(Text_1[2].trim());
            this.form.controls["dpa_contact_postcodename"].setValue(Text_1[3].trim());
            this.form.controls["dpa_contact_countryname"].setValue(Text_1[4].trim());
        }
        else {
            this.form.controls["dpa_contact_subdistict"].setValue("");
            this.form.controls["dpa_contact_distict"].setValue("");
            this.form.controls["dpa_contact_province"].setValue("");
            this.form.controls["dpa_contact_postcode"].setValue("");
            this.form.controls["dpa_contact_country"].setValue("");
            this.form.controls["dpa_contact_subdistictname"].setValue("");
            this.form.controls["dpa_contact_distictname"].setValue("");
            this.form.controls["dpa_contact_provincename"].setValue("");
            this.form.controls["dpa_contact_postcodename"].setValue("");
            this.form.controls["dpa_contact_countryname"].setValue("");
        }
    };
    ProfileRegisterComponent.prototype.CompanyTypeChange = function (value) {
        $("#divDocList").empty();
        var DivContent = '<br />';
        var Rec = this.CompanyTypeList.filter(function (a) { return a.dpa_companytypeid == value; });
        if (Rec != null && Rec.length > 0) {
            var SeqNo_1 = 1;
            this.form.controls["dpa_companytypeid"].setValue(value);
            this.form.controls["dpa_companytypeidname"].setValue(Rec[0]["dpa_name"]);
            // Rec[0]["dpa_documentgrouplist"].forEach((DocGroup: any) => {
            //   DocGroup["dpa_documentlist"].forEach((Doc: any) => {
            //     DivContent += '<label class="checktable">';
            //     DivContent += ' <input type="checkbox" class="docCheck" value="' + Doc.dpa_documentid + '"><span class="checkmark"></span>';
            //     DivContent += ' <label>' + SeqNo + '. ' + Doc.dpa_name + '</label>';
            //     DivContent += '</label>';
            //     SeqNo++;
            //   });
            // });
            Rec[0]["dpa_documentgrouplist"].forEach(function (DocGroup) {
                DivContent += '<label class="checktable">';
                DivContent += ' <input type="checkbox" class="docCheck" value="' + DocGroup.dpa_documentgroupid + '"><span class="checkmark"></span>';
                DivContent += ' <label>' + SeqNo_1 + '. ' + DocGroup.dpa_name + '</label>';
                DivContent += '</label>';
                SeqNo_1++;
            });
        }
        else {
            this.form.controls["dpa_companytypeid"].setValue("");
            this.form.controls["dpa_companytypeidname"].setValue("");
        }
        $("#divDocList").append(DivContent);
        this.DocumentList = [];
        if (Rec[0].dpa_code == "21" || Rec[0].dpa_code == "22" || Rec[0].dpa_code == "23") {
            $("#LabelRegID").addClass("required");
        }
        else {
            $("#LabelRegID").removeClass("required");
        }
    };
    ProfileRegisterComponent.prototype.PersonTypeChange = function (value) {
        $("#divDocList").empty();
        var DivContent = '<br />';
        var Rec = this.PersonTypeList.filter(function (a) { return a.dpa_personaltypeid == value; });
        if (Rec != null && Rec.length > 0) {
            this.form.controls["dpa_personaltypeid"].setValue(value);
            this.form.controls["dpa_personaltypeidname"].setValue(Rec[0]["dpa_name"]);
            var SeqNo_2 = 1;
            // Rec[0]["dpa_documentgrouplist"].forEach((DocGroup: any) => {
            //   DocGroup["dpa_documentlist"].forEach((Doc: any) => {
            //     DivContent += '<label class="checktable">';
            //     DivContent += ' <input type="checkbox" class="docCheck" value="' + Doc.dpa_documentid + '"><span class="checkmark"></span>';
            //     DivContent += ' <label>' + SeqNo + '. ' + Doc.dpa_name + '</label>';
            //     DivContent += '</label>';
            //     SeqNo++;
            //   });
            // });
            Rec[0]["dpa_documentgrouplist"].forEach(function (DocGroup) {
                DivContent += '<label class="checktable">';
                DivContent += ' <input type="checkbox" class="docCheck" value="' + DocGroup.dpa_documentgroupid + '"><span class="checkmark"></span>';
                DivContent += ' <label>' + SeqNo_2 + '. ' + DocGroup.dpa_name + '</label>';
                DivContent += '</label>';
                SeqNo_2++;
            });
            $("#dpa_idcard").off("keypress");
            if (Rec[0]["dpa_name"].includes("ต่างชาติ")) {
                $("#IdCardOrPassport").html("เลขพาสปอร์ต");
                $("#LabelBirthDate").addClass("required");
            }
            else {
                $("#IdCardOrPassport").html("เลขบัตรประชาชน");
                $("#LabelBirthDate").removeClass("required");
                var thisTs_1 = this;
                $("#dpa_idcard").on("keypress", function (e) {
                    return thisTs_1.NumericKey(e);
                });
            }
        }
        else {
            this.form.controls["dpa_personaltypeid"].setValue("");
            this.form.controls["dpa_personaltypeidname"].setValue("");
        }
        $("#divDocList").append(DivContent);
        this.DocumentList = [];
    };
    ProfileRegisterComponent.prototype.SelectDocument = function (target) {
        if (target.checked) {
            if (this.DocumentList == null || this.DocumentList == undefined)
                this.DocumentList = [];
            this.DocumentList.push({
                "dpa_documentid": target.value,
            });
        }
        else {
            this.DocumentList = this.DocumentList.filter(function (a) { return a.dpa_documentid != target.value; });
        }
    };
    ProfileRegisterComponent.prototype.CreateTableFile = function () {
        var thisTs = this;
        var TableDocs = $('#TableDocs').DataTable({
            "paging": false,
            "bFilter": false,
            "info": false,
            "data": this.FileList,
            "columns": [
                { "data": "filename", "class": "text-center" },
                { "data": "filename" },
                {
                    "data": "null",
                    "render": function (data, type, row) {
                        if (row.filesize / 1024 / 1024 < 1) {
                            return Math.floor(row.filesize / 1024) + ' KB';
                        }
                        else {
                            return (Math.round(row.filesize / 1024 / 1024 * 100 + Number.EPSILON) / 100) + ' MB';
                        }
                    },
                    "class": "text-right"
                },
                {
                    "data": null,
                    "render": function (data, type, row) {
                        return '<i class="fa fa-eye editicon cursorpointer" role="view" url="' + row.url + '" filename="' + row.filename + '" title="View"></i>' +
                            '<i class="fa fa-times deleteicon cursorpointer" role="delete" filename="' + row.filename + '" title="Delete"></i>';
                    },
                    "class": "col-btn-2 text-center"
                }
            ],
            "language": {
                "zeroRecords": "ยังไม่ได้อัปโหลดไฟล์"
            }
        });
        // TableDocs.on('click', 'tbody tr td [role=view]', function () {
        //   thisTs.ViewFile($(this).attr('url'), $(this).attr('filename'));
        // });
        // TableDocs.on('click', 'tbody tr td [role=delete]', function () {
        //   thisTs.DeleteFile($(this).attr('filename'));
        // });
        TableDocs.on('order.dt search.dt', function () {
            TableDocs.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell, i) {
                cell.innerHTML = i + 1;
            });
        }).destroy().draw();
    };
    ProfileRegisterComponent.prototype.ViewFile = function (Url, FileName) {
        if (Url == "") {
            this.Util.ErrorDialog('ไม่พบไฟล์ที่เลือก');
            return;
        }
        window.open(this.Util.CreateBlobUrl(Url), "_blank");
        // $("#FileNameTitle").html(FileName);
        // $("#ViewDocFrame").attr("src", this.Util.CreateBlobUrl(Url));
        // $('#dlgFile').modal();
        // var link = document.createElement('a');
        // link.href = this.Util.CreateBlobUrl(Url);
        // link.target = "_blank";
        // link.download = FileName;
        // link.click();
        // console.log("click!");
    };
    ProfileRegisterComponent.prototype.DeleteFile = function (FileName) {
        var _this = this;
        this.FileList.forEach(function (item, index) {
            if (item["filename"] === FileName)
                _this.FileList.splice(index, 1);
        });
        this.CreateTableFile();
    };
    ProfileRegisterComponent.prototype.FileSelect = function (File) {
        return __awaiter(this, void 0, void 0, function () {
            var FileName, FileExtension, TotalFileSize, FR, FileContent, MimeType, thisTs;
            return __generator(this, function (_a) {
                if (File.length == 0)
                    return [2 /*return*/];
                FileName = File[0]["name"];
                FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length);
                if (!this.AcceptExtension.toLowerCase().includes(FileExtension.toLowerCase())) {
                    this.Util.WarningDialog('รองรับเฉพาะไฟล์ ' + this.AcceptExtension);
                    $('#fileAttach').val('');
                    return [2 /*return*/];
                }
                TotalFileSize = File[0]["size"];
                this.FileList.forEach(function (a) {
                    TotalFileSize += +a["filesize"];
                });
                if (TotalFileSize / 1024 / 1024 > this.MaxTotalSizeMB) {
                    this.Util.WarningDialog('ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน ' + this.MaxTotalSizeMB + " MB");
                    $('#fileAttach').val('');
                    return [2 /*return*/];
                }
                if (this.FileList != null) {
                    if (this.FileList.filter(function (a) { return a.filename == File[0].name; }).length > 0) {
                        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
                        return [2 /*return*/];
                    }
                }
                FR = new FileReader();
                thisTs = this;
                FR.onload = function (e) {
                    var t = e.target;
                    FileContent = t.result;
                    MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
                    var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);
                    if (thisTs.FileList == null || thisTs.FileList == undefined)
                        thisTs.FileList = [];
                    thisTs.FileList.push({
                        "annotationid": null,
                        "filename": File[0].name,
                        "documentbody": FileContent2,
                        "mimetype": MimeType,
                        "filesize": File[0]["size"],
                        "url": FileContent
                    });
                    $('#fileAttach').val('');
                    // $('#txtFileName').val('');
                    thisTs.CreateTableFile();
                };
                FR.readAsDataURL(File[0]);
                return [2 /*return*/];
            });
        });
    };
    ProfileRegisterComponent.prototype.UploadFile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var FileInput, File, FileContent, MimeType, thisTs;
            return __generator(this, function (_a) {
                FileInput = $('#fileAttach')[0]["files"];
                if (FileInput.length == 0) {
                    this.Util.WarningDialog('กรุณาเลือกไฟล์');
                    return [2 /*return*/];
                }
                if (this.FileList != null) {
                    if (this.FileList.filter(function (a) { return a.filename == FileInput[0].name; }).length > 0) {
                        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
                        return [2 /*return*/];
                    }
                }
                File = new FileReader();
                thisTs = this;
                File.onload = function (e) {
                    var t = e.target;
                    FileContent = t.result;
                    MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
                    var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);
                    if (thisTs.FileList == null || thisTs.FileList == undefined)
                        thisTs.FileList = [];
                    thisTs.FileList.push({
                        "annotationid": null,
                        "filename": FileInput[0].name,
                        "documentbody": FileContent2,
                        "mimetype": MimeType,
                        "filesize": FileInput[0]["size"],
                        "url": FileContent
                    });
                    $('#fileAttach').val('');
                    $('#txtFileName').val('');
                    thisTs.CreateTableFile();
                };
                File.readAsDataURL(FileInput[0]);
                return [2 /*return*/];
            });
        });
    };
    ProfileRegisterComponent.prototype.ShowConsent = function () {
        $('#dlgAcceptCondition').modal();
    };
    ProfileRegisterComponent.prototype.AcceptChange = function () {
        this.AcceptChecked = $("#Accepted")[0].checked;
        if (!this.isShownConsent) {
            this.isShownConsent = true;
            this.ShowConsent();
        }
    };
    ProfileRegisterComponent.prototype.Send = function () {
        return __awaiter(this, void 0, void 0, function () {
            var DocGroup, IsValid, TicketNo, thisTs_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.Type == CustomerType.Company) {
                            if ($("#Type_Company").val() == "") {
                                this.Util.WarningDialog("กรุณาเลือกประเภทลูกค้า");
                                return [2 /*return*/];
                            }
                            DocGroup = this.CompanyTypeList.filter(function (a) { return a.dpa_companytypeid == $("#Type_Company").val(); })[0].dpa_documentgrouplist;
                        }
                        else {
                            if ($("#Type_Person").val() == "") {
                                this.Util.WarningDialog("กรุณาเลือกประเภทลูกค้า");
                                return [2 /*return*/];
                            }
                            DocGroup = this.PersonTypeList.filter(function (a) { return a.dpa_personaltypeid == $("#Type_Person").val(); })[0].dpa_documentgrouplist;
                        }
                        return [4 /*yield*/, this.ValidateInput()];
                    case 1:
                        IsValid = _a.sent();
                        if (!IsValid)
                            return [2 /*return*/];
                        if (!this.ValidateEmail(this.Type == CustomerType.Company ? $("#EMail_Company").val() : $("#EMail_Person").val()))
                            return [2 /*return*/];
                        if (!this.ValidateAccNo(this.Type == CustomerType.Company ? $("#AccountNo_Company").val() : $("#AccountNo_Person").val()))
                            return [2 /*return*/];
                        if (!this.ValidateTelephone($("#telephone1").val()))
                            return [2 /*return*/];
                        if (this.DocumentList.length == 0) {
                            this.Util.WarningDialog("กรุณาเลือกประเภทเอกสาร");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.Util.ValidateSelectedDocument(this.DocumentList, DocGroup)];
                    case 2:
                        IsValid = _a.sent();
                        if (!IsValid)
                            return [2 /*return*/];
                        if (this.FileList.length == 0) {
                            this.Util.WarningDialog("กรุณาอัปโหลดไฟล์เอกสาร");
                            return [2 /*return*/];
                        }
                        if (!this.AcceptChecked) {
                            this.Util.WarningDialog("กรุณาคลิกเลือกยอมรับนโยบาย");
                            return [2 /*return*/];
                        }
                        // let thisTs = this;
                        // $("#ReceiveNews").prop("checked", false);
                        // $("#Accepted").prop("checked", false);
                        // $('#dlgAcceptCondition').modal();
                        // $("#btnAccept").off('click');
                        // $("#btnAccept").click(async function () {
                        //   if (!$("#Accepted")[0].checked) {
                        //     //thisTs.Util.WarningDialog("กรุณาคลิกเลือกยอมรับนโยบาย");
                        //     setTimeout(function () { $("#btnCancel").click(); }, 200);
                        //     return;
                        //   }
                        //   thisTs.Util.ShowWaiting(true);
                        //   let TicketNo = await thisTs.CreateContactAndTicket();
                        //   if (TicketNo != "") {
                        //     console.log(TicketNo);
                        //     thisTs.ResetForm();
                        //     thisTs.Util.SuccessDialog("ลงทะเบียนยืนยันตัวตนสำเร็จ เลขรับเรื่องคือ " + TicketNo);
                        //     setTimeout(function () { $("#btnCancel").click(); }, 200);
                        //   }
                        //   thisTs.Util.ShowWaiting(false);
                        // });
                        this.Util.ShowWaiting(true);
                        return [4 /*yield*/, this.CreateContactAndTicket()];
                    case 3:
                        TicketNo = _a.sent();
                        if (TicketNo != "") {
                            console.log(TicketNo);
                            this.ResetForm();
                            this.Util.SuccessDialog("ลงทะเบียนยืนยันตัวตนสำเร็จ เลขรับเรื่องคือ " + TicketNo);
                            thisTs_2 = this;
                            $('#btnSuccessOK').off('click');
                            $('#btnSuccessOK').on('click', function () {
                                thisTs_2.Router.navigate(['/mainmenu/ticketlist']);
                            });
                        }
                        this.Util.ShowWaiting(false);
                        $("#ReceiveNews").prop("checked", false);
                        $("#Accepted").prop("checked", false);
                        this.AcceptChecked = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ProfileRegisterComponent.prototype.CreateContactAndTicket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var PortalUsername, dob, DocList, TotalFileSize_1, TicketID, ContactID, Res, Contact, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (this.Type == CustomerType.Person) {
                            if (this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ")) {
                                this.form.controls["dpa_passport"].setValue(this.form.get("dpa_idcard").value);
                                this.form.controls["dpa_idcard"].setValue("");
                            }
                            else
                                this.form.controls["dpa_passport"].setValue("");
                            this.form.controls["dpa_accountno"].setValue($("#AccountNo_Person").val());
                            this.form.controls["emailaddress1"].setValue($("#EMail_Person").val());
                            dob = $('#birthdate').val();
                            if (dob == null || dob.trim().length == 0) {
                                this.form.controls["birthdate"].setValue("");
                            }
                            else {
                                this.form.controls["birthdate"].setValue($('#birthdate').data('datepicker').date.toISOString());
                            }
                        }
                        else {
                            // this.form.controls["dpa_contacttype"].setValue("3");
                            this.form.controls["dpa_accountno"].setValue($("#AccountNo_Company").val());
                            this.form.controls["emailaddress1"].setValue($("#EMail_Company").val());
                            this.form.controls["dpa_authorizedperson"].setValue($("#AuthorizedFirstName").val() + " " + $("#AuthorizedLastName").val());
                            this.form.controls["telephone1"].setValue(this.form.get("dpa_authorizedperson_telephone").value);
                        }
                        // this.PortalLogin = await this.Api.getPortal("user", "getuser", "username=" + this.form.get("emailaddress1").value);
                        // if (this.PortalLogin != null && this.PortalLogin.length > 0) {
                        //   this.Util.WarningDialog("E-mail '" + this.form.get("emailaddress1").value + "' ถูกใช้งานแล้ว");
                        //   if (this.form.get("dpa_passport").value != "")
                        //     this.form.controls["dpa_idcard"].setValue(this.form.get("dpa_passport").value);
                        //   return '';
                        // }
                        this.form.controls["dpa_allowemail"].setValue($("#ReceiveNews")[0].checked);
                        this.form.controls["dpa_allowsms"].setValue($("#ReceiveNews")[0].checked);
                        this.form.controls["dpa_originalsource"].setValue(2);
                        this.form.controls["dpa_contactid"].setValue(null);
                        this.form.controls["dpa_submitdate"].setValue((new Date()).toISOString());
                        DocList = "";
                        this.DocumentList.forEach(function (a) {
                            DocList += (DocList == "" ? "" : "|") + a.dpa_documentid;
                        });
                        this.form.controls["dpa_documentchecklist"].setValue(DocList);
                        TotalFileSize_1 = 0;
                        this.FileList.forEach(function (a) {
                            var Decoded = atob(a.documentbody);
                            a.filesize = Decoded.length;
                            TotalFileSize_1 += a.filesize;
                            a.url = "";
                        });
                        this.form.controls["attachfilelist"].setValue(this.FileList);
                        this.form.controls["dpa_attachsizing"].setValue(TotalFileSize_1);
                        TicketID = '', ContactID = '';
                        this.form.controls["dpa_agentbankflag"].setValue(true);
                        this.form.controls["dpa_portalflag"].setValue(false);
                        // let code = this.form.controls["dpa_approvalstatuscode"].value
                        this.form.controls["dpa_approvalstatusid"].setValue(this.GetStatusGuidByCode("01"));
                        return [4 /*yield*/, this.Api.post('crmservice', 'approvalTicket', this.form.value)];
                    case 1:
                        Res = _a.sent();
                        if (Res.RESMSG != null && Res.RESMSG != undefined) {
                            if (Res.RESMSG == "มีข้อมูลในระบบแล้ว") {
                                if (this.form.get("dpa_idcard").value != "") {
                                    this.Util.WarningDialog("เลขบัตรประชาชนหรือ E-Mail มีอยู่ในระบบแล้ว");
                                }
                                else if (this.form.get("dpa_passport").value != "") {
                                    this.Util.WarningDialog("เลขพาสปอร์ตหรือ E-Mail มีอยู่ในระบบแล้ว");
                                    this.form.controls["dpa_idcard"].setValue(this.form.get("dpa_passport").value);
                                }
                                else {
                                    this.Util.WarningDialog("เลขประจำตัวผู้เสียภาษี / เลขนิติบุคคลหรือ E-Mail มีอยู่ในระบบแล้ว");
                                }
                                return [2 /*return*/, ''];
                            }
                            else if (Res["dpa_name"] == null || Res["dpa_name"] == undefined) {
                                this.Util.WarningDialog("ไม่สามารถบันทึกข้อมูลได้");
                                return [2 /*return*/, ''];
                            }
                        }
                        TicketID = Res["dpa_name"];
                        ContactID = Res["contactid"];
                        return [4 /*yield*/, this.Api.get("crmservice", "contact", "contactid=" + ContactID)];
                    case 2:
                        Contact = _a.sent();
                        Contact = Contact[0];
                        if (this.Type == CustomerType.Person) {
                            this.PortalLogin = {
                                firstname: this.form.get("firstname").value,
                                lastname: this.form.get("lastname").value,
                                usernameidno: this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ") ? this.form.get("dpa_passport").value : this.form.get("dpa_idcard").value,
                                username: this.form.get("emailaddress1").value,
                                password: '',
                                passwordold1: '',
                                isactive: "1",
                                customerid: ContactID,
                                createOn: null,
                                createBy: localStorage.getItem("AgentBank_Profile"),
                                pid: null,
                                modifiedOn: null,
                                modifiedBy: null
                            };
                        }
                        else {
                            this.PortalLogin = {
                                firstname: $("#AuthorizedFirstName").val(),
                                lastname: $("#AuthorizedLastName").val(),
                                usernameidno: Contact.dpa_registrationid,
                                username: this.form.get("emailaddress1").value,
                                password: '',
                                passwordold1: '',
                                isactive: "1",
                                customerid: ContactID,
                                createOn: null,
                                createBy: localStorage.getItem("AgentBank_Profile"),
                                pid: null,
                                modifiedOn: null,
                                modifiedBy: null
                            };
                        }
                        this.PortalLogin.dpa_agentbankuserid = localStorage.getItem("AgentBank_UserID");
                        this.PortalLogin.call_by = "3";
                        this.PortalLogin.url = environment.webPortalUrl;
                        return [4 /*yield*/, this.Api.postPortal("user", "InsertUser", this.PortalLogin)];
                    case 3:
                        // this.PortalLogin.username = this.form.get("emailaddress1").value;
                        // this.PortalLogin.password = '';
                        // this.PortalLogin.passwordold1 = '';
                        // this.PortalLogin.isactive = "1";
                        // this.PortalLogin.customerid = ContactID;
                        // this.PortalLogin.createOn = null;
                        // this.PortalLogin.createBy = localStorage.getItem("AgentBank_Profile");
                        // this.PortalLogin.pid = null;
                        // this.PortalLogin.modifiedOn = null;
                        // this.PortalLogin.modifiedBy = null;
                        Res = _a.sent();
                        console.log(Res);
                        // let Token: any = {
                        //   username: this.PortalLogin.username,
                        //   usernameidno: this.PortalLogin.usernameidno,
                        //   usertype: this.Type == CustomerType.Person ? "1" : "2",
                        //   createBy: localStorage.getItem("AgentBank_Profile"),
                        //   firstname: this.PortalLogin.firstname,
                        //   lastname: this.PortalLogin.lastname,
                        //   ticketNo: TicketID,
                        //   call_by: "3",
                        //   url: this.Util.baseUrl()
                        // };
                        // Res = await this.Api.postPortal("user", "CreateToken", Token);
                        // if (Res != null) {
                        //   Res = await this.SendEmail(Res.token_id, TicketID);
                        // }
                        // console.log(Res);
                        this.ResetForm();
                        return [2 /*return*/, TicketID];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        this.Util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ");
                        if (this.form.get("dpa_passport").value != "")
                            this.form.controls["dpa_idcard"].setValue(this.form.get("dpa_passport").value);
                        return [2 /*return*/, ''];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ProfileRegisterComponent.prototype.SendEmail = function (TokenID, TicketNo) {
        return __awaiter(this, void 0, void 0, function () {
            var MailObj, portUtl, MailContent, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        MailObj = {
                            contactid: this.PortalLogin.customerid,
                            dpa_name: this.PortalLogin.firstname + " " + this.PortalLogin.lastname
                        };
                        return [4 /*yield*/, this.Api.getConfig(6)];
                    case 1:
                        portUtl = _a.sent();
                        MailContent = "เรียน คุณ" + this.PortalLogin.firstname + " " + this.PortalLogin.lastname + "<br /><br />" +
                            "   คุณได้ลงทะเบียนเพื่อเข้าใช้งานระบบ Customer Web Portal ของสถาบันคุ้มครองเงินฝาก <br />" +
                            "รหัสผู้ใช้งานของคุณคือ : " + this.PortalLogin.usernameidno + " เลขที่รับเรื่อง: " + TicketNo + "<br />" +
                            " โปรดคลิกลิงค์ด้านล่างเพื่อตั้งรหัสผ่าน <br /><br />" +
                            "<a href='" + portUtl + "/resetpassword?id=" + TokenID + "'>" +
                            portUtl + "/resetpassword?id=" + TokenID + "</a><br /><br />" +
                            "ขอแสดงความนับถือ <br />" +
                            "สถาบันคุ้มครองเงินฝาก <br />" +
                            "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
                            "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
                            "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
                            "โทร : 02-272-0300";
                        MailObj.dpa_description = MailContent;
                        MailObj.dpa_callby = 3;
                        return [4 /*yield*/, this.Api.post("crmservice", "sendEmail", MailObj)];
                    case 2:
                        Res = _a.sent();
                        return [2 /*return*/, Res];
                }
            });
        });
    };
    ProfileRegisterComponent.prototype.CreateTicket = function (ContactID) {
        return __awaiter(this, void 0, void 0, function () {
            var DocList, TicketNo, Res, Token, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        this.ticket.controls["dpa_contactid"].setValue(ContactID);
                        this.ticket.controls["dpa_submitdate"].setValue(new Date().toISOString());
                        DocList = "";
                        this.DocumentList.forEach(function (a) {
                            DocList += (DocList == "" ? "" : "|") + a.dpa_documentid;
                        });
                        this.ticket.controls["dpa_documentchecklist"].setValue(DocList);
                        this.ticket.controls["attachfilelist"].setValue(this.FileList);
                        this.ticket.controls["dpa_attachsizing"].setValue("0");
                        // let code = this.ticket.controls["dpa_approvalstatuscode"].value
                        this.ticket.controls["dpa_approvalstatusid"].setValue(this.GetStatusGuidByCode("01"));
                        TicketNo = '';
                        return [4 /*yield*/, this.Api.post('crmservice', 'approvalticket', this.ticket.value)];
                    case 1:
                        Res = _a.sent();
                        TicketNo = Res["dpa_name"];
                        Token = {
                            username: this.PortalLogin.username,
                            usernameidno: this.PortalLogin.usernameidno,
                            usertype: this.Type == CustomerType.Person ? "1" : "2",
                            createBy: localStorage.getItem("AgentBank_Profile"),
                            contactid: Res["contactid"]
                        };
                        return [4 /*yield*/, this.Api.postPortal("user", "CreateToken", Token)];
                    case 2:
                        Res = _a.sent();
                        if (!(Res != null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.SendEmail(Res.token_id, TicketNo)];
                    case 3:
                        Res = _a.sent();
                        _a.label = 4;
                    case 4:
                        console.log(Res);
                        return [2 /*return*/, TicketNo];
                    case 5:
                        err_2 = _a.sent();
                        console.log(err_2);
                        this.Util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ");
                        return [2 /*return*/, ''];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ProfileRegisterComponent.prototype.ResetForm = function () {
        var thisTs = this;
        this.form.reset();
        $("#AccountNo_Person").val("");
        $("#EMail_Person").val("");
        $("#birthdate").val("");
        $("#AccountNo_Company").val("");
        $("#EMail_Company").val("");
        $("#AuthorizedLastName").val("");
        $("#AuthorizedFirstName").val("");
        $("#SelectAddress").val("").trigger("change");
        this.FileList = [];
        this.DocumentList = [];
        this.CreateTableFile();
        if (this.Type == CustomerType.Person)
            this.PersonTypeChange($("#Type_Person").val());
        else
            this.CompanyTypeChange($("#Type_Company").val());
        $('.docCheck').on("change", function (e) {
            thisTs.SelectDocument(e.target);
        });
    };
    ProfileRegisterComponent.prototype.ValidateInput = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var MissRequiredField, IsForeigner, CompanyTypeCode;
            return __generator(this, function (_a) {
                MissRequiredField = false;
                if (this.Type == CustomerType.Person) {
                    IsForeigner = true;
                    if (!this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ")) {
                        if (this.form.get("dpa_idcard").value != null && this.form.get("dpa_idcard").value != "" && !this.Util.ValidateCitizenID(this.form.get("dpa_idcard").value)) {
                            this.Util.WarningDialog("เลขบัตรประชาชนไม่ถูกต้อง");
                            return [2 /*return*/, false];
                        }
                        IsForeigner = false;
                    }
                    MissRequiredField = this.form.get("firstname").value == "" || this.form.get("firstname").value == null ||
                        this.form.get("lastname").value == "" || this.form.get("lastname").value == null ||
                        this.form.get("dpa_idcard").value == "" || this.form.get("dpa_idcard").value == null ||
                        $("#AccountNo_Person").val() == "" || $("#AccountNo_Person").val() == null ||
                        $("#EMail_Person").val() == "" || $("#EMail_Person").val() == null ||
                        this.form.get("telephone1").value == "" || this.form.get("telephone1").value == null ||
                        (IsForeigner && this.form.get("birthdate").value == "");
                }
                else {
                    if (this.form.get("dpa_authorizedperson_idcard").value != "" && this.form.get("dpa_authorizedperson_idcard").value != null && !this.Util.ValidateCitizenID(this.form.get("dpa_authorizedperson_idcard").value)) {
                        this.Util.WarningDialog("เลขบัตรประชาชนไม่ถูกต้อง");
                        return [2 /*return*/, false];
                    }
                    CompanyTypeCode = this.CompanyTypeList.filter(function (a) { return a.dpa_companytypeid == _this.form.get("dpa_companytypeid").value; })[0].dpa_code;
                    MissRequiredField = this.form.get("dpa_companyname").value == "" || this.form.get("dpa_companyname").value == null ||
                        this.form.get("dpa_authorizedperson_idcard").value == "" || this.form.get("dpa_authorizedperson_idcard").value == null ||
                        this.form.get("dpa_authorizedperson_telephone").value == "" || this.form.get("dpa_authorizedperson_telephone").value == null ||
                        $("#AuthorizedFirstName").val() == "" || $("#AuthorizedFirstName").val() == null ||
                        $("#AuthorizedLastName").val() == "" || $("#AuthorizedLastName").val() == null ||
                        $("#AccountNo_Company").val() == "" || $("#AccountNo_Company").val() == null ||
                        $("#EMail_Company").val() == "" || $("#EMail_Company").val() == null ||
                        ((CompanyTypeCode == "21" || CompanyTypeCode == "22" || CompanyTypeCode == "23") &&
                            (this.form.get("dpa_registrationid").value == null || this.form.get("dpa_registrationid").value == ""));
                }
                MissRequiredField = MissRequiredField || $("#SelectAddress").val() == null || $("#SelectAddress").val() == "";
                if (MissRequiredField) {
                    this.Util.WarningDialog("กรุณาระบุข้อมูลบังคับ (*) ให้ครบถ้วน");
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
            });
        });
    };
    ProfileRegisterComponent.prototype.GoBackHome = function () {
        this.Router.navigate(["/mainmenu/ticketlist"]);
    };
    ProfileRegisterComponent.prototype.ValidateTelephone = function (Value) {
        for (var i = 0; i < Value.length; i++) {
            if (isNaN(Value[i]) && Value[i] != "-" && Value[i] != ",") {
                this.Util.WarningDialog("หมายเลขโทรศัพท์ไม่ถูกต้อง");
                return false;
            }
        }
        return true;
    };
    ProfileRegisterComponent.prototype.TelephoneKey = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            if (charCode == 35 || charCode == 44 || charCode == 45) {
                return true;
            }
            return false;
        }
        return true;
    };
    ProfileRegisterComponent.prototype.NumericKey = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    };
    ProfileRegisterComponent.prototype.ValidateEmail = function (Value) {
        var Match = Value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
        if (!Match) {
            this.Util.WarningDialog("E-Mail ไม่ถูกต้อง");
        }
        return Match;
    };
    ProfileRegisterComponent.prototype.ValidateAccNo = function (Value) {
        for (var i = 0; i < Value.length; i++) {
            if (isNaN(Value[i])) {
                this.Util.WarningDialog("เลขที่บัญชีไม่ถูกต้อง");
                return false;
            }
        }
        return true;
    };
    ProfileRegisterComponent.prototype.GetStatusGuidByCode = function (code) {
        var found = this.masterStatus.filter(function (s) {
            return s.dpa_code == code;
        });
        if (found != null && found.length > 0) {
            return found[0].dpa_approvalstatusid;
        }
        else {
            return null;
        }
    };
    return ProfileRegisterComponent;
}());
export { ProfileRegisterComponent };



// WEBPACK FOOTER //
// ./src/app/profile-register/profile-register.component.ts.pre-build-optimizer.js